module.exports = __webpack_public_path__ + "img/banner4.0891674b.jpg";